class NSSFooter extends HTMLElement {
  constructor() {
    super();
    this.debug = false;
  }

  connectedCallback() {
    if (this.debug) console.log(`[NSS][Footer] Connected.`);

    // Mobile: menu columns behave as accordion drawers (design Footer - Mobile).
    // Titles toggle an attribute the CSS collapses against; desktop ignores it.
    this.querySelectorAll(`.nss-footer__menu-title`).forEach((titleEl) => {
      titleEl.addEventListener(`click`, () => {
        const menuEl = titleEl.closest(`.nss-footer__menu`);
        if (!menuEl) return;
        const open = menuEl.getAttribute(`nss-footer-drawer-open`) === `true`;
        // Exclusive drawers (QA 86ajmvxdf): opening one closes the others.
        if (!open) {
          this.querySelectorAll(`.nss-footer__menu[nss-footer-drawer-open="true"]`).forEach((openEl) => {
            openEl.setAttribute(`nss-footer-drawer-open`, `false`);
          });
        }
        menuEl.setAttribute(`nss-footer-drawer-open`, open ? `false` : `true`);
      });
    });

    // Newsletter signup also feeds the Klaviyo list directly (list ID and
    // company/public-API-key live on the wrapper, not the Shopify customer
    // form itself — this store has more than one Klaviyo integration script
    // in <head> with different company IDs, so the key can't be sniffed off
    // whichever one happens to load first).
    const newsletterWrap = this.querySelector(`.nss-footer__newsletter`);
    const newsletterForm = newsletterWrap && newsletterWrap.querySelector(`form`);
    const klaviyoListId = newsletterWrap && newsletterWrap.dataset.klaviyoListId;
    const klaviyoCompanyId = newsletterWrap && newsletterWrap.dataset.klaviyoCompanyId;
    if (newsletterForm && klaviyoListId && klaviyoCompanyId) {
      newsletterForm.addEventListener(`submit`, () => {
        const emailInput = newsletterForm.querySelector(`input[name="contact[email]"]`);
        const email = emailInput && emailInput.value;
        if (!email) return;
        // The legacy kmail-lists GET pixel only pings Klaviyo (creates/identifies
        // a profile) — it never actually joins the list, which requires a real
        // POST. Klaviyo's public Client API replaces it. `keepalive` keeps the
        // request alive past the page navigation the form submit triggers.
        fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${klaviyoCompanyId}`, {
          method: `POST`,
          keepalive: true,
          headers: {
            "Content-Type": `application/vnd.api+json`,
            revision: `2024-10-15`
          },
          body: JSON.stringify({
            data: {
              type: `subscription`,
              attributes: {
                custom_source: `Footer Newsletter Form`,
                profile: {
                  data: {
                    type: `profile`,
                    attributes: { email }
                  }
                }
              },
              relationships: {
                list: {
                  data: {
                    type: `list`,
                    id: klaviyoListId
                  }
                }
              }
            }
          })
        }).catch(() => {});
      });
    }
  }
}

let elementName = `nss-footer`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSFooter);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}
